<table class='table table-silver'>
  <thead>
  <tr>
    <th style='width: 20rem'></th>
    <th>
      Szerokość
    </th>
    <th>
      Długość
    </th>
    <th>
      Powierzchnia
    </th>
  </tr>
  </thead>
  <tbody>
    @for (fee of stage?.purposeFees; track $index) {
      <tr>
        <td class='align-left'>
          <strong>
            <small>
              {{ fee.name }}
            </small>
          </strong>
        </td>
        <td>
          {{ fee.width + '' | toNumber | number }} m
        </td>
        <td>
          {{ fee.length + '' | toNumber | number }} m
        </td>
        <td>
          {{ fee.area + '' | toNumber | number }} m<sup>2</sup>
        </td>
      </tr>
    }
  </tbody>
</table>
